import { OrganizationRole } from './clinician';

export interface IUsername {
  first: string;
  last: string;
  middle?: string | null;
  credentials?: string | null;
}

export interface IDemographics {
  sex: 'MALE' | 'FEMALE';
  dob: string;
}

export interface Address {
  city: string;
  postal_code: string;
  region: string;
  street_address: string;
  street_address_2?: string;
  country?: string;
}

export interface IContact {
  phone: string;
  address: Address;
}

export enum UserRole {
  ORDERING_PROVIDER = 'ORDERING_PROVIDER',
  GENETIC_COUNSELOR = 'GENETIC_COUNSELOR',
  CLINICAL_STAFF_MEMBER = 'CLINICAL_STAFF_MEMBER',
  CLINICAL_RESEARCHER = 'CLINICAL_RESEARCHER',
  LAB_MANAGER = 'LAB_MANAGER',
  OTHER = 'OTHER',
}

export enum HasTeamMemberOption {
  NO = 'No',
  YES = 'Yes',
}

export interface IProfile {
  name: IUsername;
  role: UserRole;
  npi?: string;
  email: string;
  phone?: string;
  fax?: string;
}

export interface ITeamMember extends IProfile {
  id?: string;
}

export interface IOrganization {
  name: string;
  phone: string;
  fax?: string;
  address: Address;
  partner_clinic_id?: string;
}

export interface ISignupForm {
  signup_code?: string;
  provider: IProfile;
  has_teammates: boolean;
  teammates: ITeamMember[];
  organization: IOrganization;
}

export interface ICreateProviderForm {
  provider: Omit<IProfile, 'role'>;
  organization_provider_roles: OrganizationRole[];
}

export interface ProviderMemberCampaign {
  campaign_code: string;
  name: string;
  description: string;
}

export interface ProviderMemberClinic {
  clinic_id: string;
  name: string;
  roles: OrganizationRole[];
}

export interface ProviderCommunicationPreferences {
  results_email: boolean;
}

export interface ProviderUserProfile {
  // Identifiers
  provider_id: string;
  npi: string;
  hubspot_id_token: string | null;
  // Demographics
  first_name: string;
  last_name: string;
  credentials: string | null;
  // Contact Info
  email: string;
  phone: string;
  address: Address;
  communication_preferences: ProviderCommunicationPreferences;
  // Relations
  campaigns: ProviderMemberCampaign[];
  clinics: ProviderMemberClinic[];
}
